module.exports = __webpack_public_path__ + "img/engagement_rings.2ef1416.jpg";